import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'carrier',
})
export class CarrierPipe implements PipeTransform {

   transform(value: any): any {
        switch (+value) {
            case 0:
                return 'NOTSET';
            case 1:
                return 'UPS';
            case 2:
                return 'FEDEX';
            case 3:
                return 'DHL';
            case 4:
                return 'USPS';
            default:
                return value;
        }
    }

}
